import { useMemo, useContext } from 'react';
import { PatientChartContext } from '../../../contexts/patientChart';
import {
  APPROVAL_VALIDATION_ERROR,
  PRODUCT_TYPE, ACTION_TYPE,
  JUMP_START_INFO,
} from '../../../constants/patientChart.constant';
import DoseSpotUI, { DoseSpotActions } from '../DoseSpotUI';

/**
 * @param {{
 *  orderId: number;
 *  doctorId: number;
 *  doseSpot: {
 *    StringValue: string;
 *    openCommonModal: boolean;
 *  };
 *  resetDoseSpot: () => Promise<{}>;
 *  modifyDoseSpotPrescription: (props: {
 *    OrderId: string;
 *    DoctorId: string;
 *  }) => Promise<{}>;
 * }} params
 * @returns {React.JSX.Element}
 */
export const Approve = ({
  orderId = 0,
  doctorId,
  resetDoseSpot = async () => {},
  modifyDoseSpotPrescription,
}) => {
  const { jumpStart, setJumpStart } = useContext(PatientChartContext);

  const validationError = useMemo(() => {
    const validationError = APPROVAL_VALIDATION_ERROR();
    validationError.set('generic-template', { field: 'generic-field', message: '' });
    return validationError;
  }, []);

  const { doseSpotURL, rxPID } = useMemo(() => {
    const defaultType = {
      hasAlternateRx: true,
      rxPID: jumpStart.productId,
      doseSpotURL: jumpStart.url,
      productType: PRODUCT_TYPE.alternateRx,
      actionType: ACTION_TYPE.alternateRx,
    };

    return defaultType;
  }, [jumpStart]);

  const handleApproveViaDoseSpot = async () => {
  };

  const handleCancel = async () => {
    setJumpStart(JUMP_START_INFO());
    resetDoseSpot();
    modifyDoseSpotPrescription({
      OrderId: `${orderId}`,
      DoctorId: `${doctorId}`,
    });
  };

  return (
    <div className='flex flex-column flex-fill m-5 patient-chart-container'>
      <DoseSpotUI url={doseSpotURL} productId={rxPID} orderId={orderId} />
      <DoseSpotActions
        validationError={validationError}
        cancelButtonLabel='Close'
        onApprove={handleApproveViaDoseSpot}
        onCancel={handleCancel}
      />
    </div>
  );
};

export default Approve;
